import React from "react";
import styled from "styled-components";
import {
    DirectionWrapper, EarningsWrapper, EntryPriceWrapper, LifetimePerfWrapper, PortfolioDetailsWrapper,
    RestrictionIconWrapper, StockDetailsWrapper, TableRow, TimeOpenWrapper, TodayPerfWrapper
} from "./IdeaRow";
import {authorBackgroundColour} from "../../../../style/styleConsts";
import {SortableHeading} from "../../../sorting/SortableHeading";
import {DirectionColumn} from "../../idea/Direction";
import {PerformanceColumnHeading} from "../../idea/Performance";
import {PortfolioCountColumn} from "./PortfolioCount";
import {TimeOpenColumn} from "./HomepageTimeOpen";
import {MoreDetailsHeader} from "./MoreDetailsButton";
import {PriceHeader} from "../../idea/Price";
import {StockColumn} from "../../idea/Stock";

const HeaderContainer = styled(TableRow)`
    font-size: 11px;
    flex-grow: 0;
    flex-shrink: 0;    
    border-bottom: 1px solid rgba(159, 167, 178, 0.32);
    background-color: ${authorBackgroundColour};
    height: 45px;
`;

export const IdeasTableHeader = (props) => {
    const {authorActions, sort, tableHasScroll} = props;
    const padRight = tableHasScroll;

    const OpenIdeasHeading = (props) => (
        <SortableHeading {...props}
                         sortState={sort}
                         tableName="homepage_openIdeas"
                         sortByFieldFn={authorActions.sortOpenIdeasBy}/>
    );

    return <HeaderContainer padRight={padRight}>
        <DirectionWrapper>
            <DirectionColumn>
                <OpenIdeasHeading descendingFirst={false}
                                  fieldName="direction">
                    L/S
                </OpenIdeasHeading>
            </DirectionColumn>
        </DirectionWrapper>

        <StockDetailsWrapper>
            <StockColumn>
                <OpenIdeasHeading descendingFirst={false} fieldName="bloomberg">
                    Stock
                </OpenIdeasHeading>
            </StockColumn>
        </StockDetailsWrapper>

        <RestrictionIconWrapper/>

        <EarningsWrapper>
            <OpenIdeasHeading horizontalAlignment="center"
                              descendingFirst={false}
                              fieldName="earningsSort">
                Earnings
            </OpenIdeasHeading>
        </EarningsWrapper>

        <TimeOpenWrapper>
            <TimeOpenColumn>
                <OpenIdeasHeading horizontalAlignment="flex-end"
                                  arrowRight={false}
                                  fieldName="timeOpenMillis">
                    <div>Time Open</div>
                </OpenIdeasHeading>
            </TimeOpenColumn>
        </TimeOpenWrapper>

        <EntryPriceWrapper>
            <PriceHeader>
                Entry Price
            </PriceHeader>
        </EntryPriceWrapper>

        <TodayPerfWrapper>
            <OpenIdeasHeading horizontalAlignment="flex-end"
                              arrowRight={false}
                              fieldName="relativeReturnToday">
                <PerformanceColumnHeading>
                    <div>Rel Ret</div>
                    <div>(Today)</div>
                </PerformanceColumnHeading>
            </OpenIdeasHeading>
        </TodayPerfWrapper>

        <LifetimePerfWrapper>
            <OpenIdeasHeading horizontalAlignment="flex-end"
                              arrowRight={false}
                              fieldName="relativeReturnLifetime">
                <PerformanceColumnHeading>
                    <div>Rel Ret</div>
                    <div>(Lifetime)</div>
                </PerformanceColumnHeading>
            </OpenIdeasHeading>
        </LifetimePerfWrapper>

        <PortfolioDetailsWrapper>
            <PortfolioCountColumn>
                <OpenIdeasHeading horizontalAlignment="flex-end"
                                  arrowRight={false}
                                  fieldName="portfolioCount">
                    <div>Portfolio(s)</div>
                </OpenIdeasHeading>
            </PortfolioCountColumn>
        </PortfolioDetailsWrapper>


        <MoreDetailsHeader ideaManagementBlocked={props.ideaManagementBlocked}/>

    </HeaderContainer>;
};